export enum ProductFormTypeEnum {
	CREATE= 'Create',
	EDIT = 'Edit',
	VIEW =  'View'
}